import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


export function ProxiesPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen relative">
      <div className="container mx-auto px-4 py-16 content-overlay">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-8 text-center animate-slide-up">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-brand-accent mb-4">
              {t('proxies.title')}
            </h1>
            <p className="text-neutral-medium text-lg font-body">
              {t('proxies.subtitle')}
            </p>
          </div>

          {/* Actions */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            {/* Purchase Card */}
            <div className="card-glass rounded-2xl shadow-2xl p-8 animate-scale-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-brand-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-brand-accent"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl font-heading font-semibold text-neutral-light mb-2">
                  {t('proxies.purchase.title')}
                </h2>
                <p className="text-neutral-medium font-body">
                  {t('proxies.purchase.subtitle')}
                </p>
              </div>
              <Link
                to="/proxies/purchase"
                className="w-full block px-6 py-3 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300 text-center"
              >
                {t('proxies.purchase.cta')}
              </Link>
            </div>

            {/* List Card */}
            <div className="card-glass rounded-2xl shadow-2xl p-8 animate-scale-in">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-brand-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg
                    className="w-8 h-8 text-brand-accent"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <h2 className="text-2xl font-heading font-semibold text-neutral-light mb-2">
                  {t('proxies.list.title')}
                </h2>
                <p className="text-neutral-medium font-body">
                  {t('proxies.list.subtitle')}
                </p>
              </div>
              <Link
                to="/proxies/list"
                className="w-full block px-6 py-3 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300 text-center"
              >
                {t('proxies.list.viewMyProxies')}
              </Link>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/proxies/list"
              className="px-6 py-3 bg-brand-accent text-brand-primary font-heading font-semibold rounded-lg hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300 text-center"
            >
              {t('proxies.list.title')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

